function numberWithCommas(x: number) {
  return new Intl.NumberFormat('en-US').format(x).replace(',', ' ').replaceAll('.', ',');
}
export function formatCurrency(value: number, currency: string) {
  return `${numberWithCommas(value)} ${currency}`;
}
